import type { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VFlex, VStack } from '@/package';
import type { ModelTrainingForm, Task } from '@/type';

import SplitCardContainer from './SplitCardContainer';

type SetupCompleteProps = {
  watch: UseFormWatch<ModelTrainingForm>;
  setValue: UseFormSetValue<ModelTrainingForm>;
  SelectModel: React.ReactNode;
  updateTaskSplitRatio: (
    taskId: Task['id'],
    training: number,
    validation: number,
  ) => void;
  getTaskSplitRatio: (taskId: Task['id']) => {
    training: number;
    validation: number;
  };
};

const SetupComplete = ({
  watch,
  setValue,
  SelectModel,
  updateTaskSplitRatio,
  getTaskSplitRatio,
}: SetupCompleteProps) => {
  const { t } = useTranslation();

  const dataSettingMode = watch('dataSettingMode');

  const splitText =
    dataSettingMode === 'auto'
      ? t('modeling.autoSplit.saintlike')
      : t('modeling.userSplit.headpenny');

  return (
    <VStack gap={1} className="w-full">
      <div className="text-headline-sm font-bold text-blue-300">
        Select a Model
      </div>

      {SelectModel}

      <div className="h-px bg-gray-300" />

      <VFlex justify="between" items="center">
        <div className="text-headline-sm font-bold text-blue-300">
          Data setting
        </div>
        <VFlex
          justify="center"
          items="center"
          className="rounded-md bg-gray-200 px-4 py-1 text-body-lg font-semibold text-primary-500"
        >
          {splitText}
        </VFlex>
      </VFlex>

      <SplitCardContainer
        disabled={true}
        watch={watch}
        setValue={setValue}
        updateTaskSplitRatio={updateTaskSplitRatio}
        getTaskSplitRatio={getTaskSplitRatio}
      />
    </VStack>
  );
};

export default SetupComplete;
